import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@redux/hooks";
import {
  onboardStudent,
  resetOnboardStudent,
} from "@user-management-context/write/application/use-cases/student-onboarding/onboard-student";
import { selectStudentOnboarding } from "@user-management-context/write/application/use-cases/student-onboarding/selectors/student-onboarding-selectors";
import { useApiAction } from "@shared-kernel/primary/shared/api-errors/use-api-action";
import { applyApiFieldErrors } from "@shared-kernel/primary/shared/api-errors/apply-api-field-errors";
import type { ActionForm } from "@shared-kernel/primary/shared/api-errors/action-form";
import { useResetWhenSettled } from "@shared-kernel/primary/shared/request-state/use-reset-when-settled";
import type { StudentOnboardingFormInputs } from "./form-validation/full-form.schema";
import { formatFormDataToOnboardStudentBody } from "./form-validation/shared";

export const useStudentOnboarding = (form: ActionForm<StudentOnboardingFormInputs>) => {
  const run = useApiAction();
  const navigate = useNavigate();
  const { processing } = useAppSelector(selectStudentOnboarding);
  useResetWhenSettled(processing, resetOnboardStudent);

  // L'API dit pourquoi l'onboarding est refusé (profil élève déjà créé), sous le champ fautif quand elle le désigne
  const onboard = useCallback(
    async (values: StudentOnboardingFormInputs) => {
      const outcome = await run(onboardStudent(formatFormDataToOnboardStudentBody(values)), {
        success: "Votre profil élève est prêt !",
        failure: "Erreur lors de la finalisation de votre profil élève",
      });
      if (!outcome.ok) {
        applyApiFieldErrors(form, outcome.error);
        return;
      }
      navigate("/onboarding");
    },
    [run, navigate, form],
  );

  return { onboard };
};
